import { useCallback, useRef } from 'react';
import { getElementSize, getWindowSize } from '../../utils/dom';
const directions = ['up', 'right', 'down', 'left'];
export const padding = 8;
export const directionAlias = {
    up: 'top',
    down: 'bottom',
    left: 'left',
    right: 'right',
};
export function useTooltip() {
    const controls = useRef(new Set([]));
    const container = useRef(null);
    const registerControl = useCallback((el) => el && controls.current.add(el), []);
    return {
        to: controls,
        container,
        registerControl,
    };
}
export function toClickOutside(popper) {
    var _a;
    return [{ current: (_a = popper.current) === null || _a === void 0 ? void 0 : _a.state.elements.reference }];
}
export function fit({ containerEl, controlEl, tooltipEl, directionEl }) {
    const box = containerEl ? getElementSize(containerEl) : getWindowSize();
    const origin = getElementSize(document.body);
    const control = getElementSize(controlEl);
    const tooltip = getElementSize(tooltipEl);
    const cleft = control.left - origin.left;
    const cright = control.right - origin.left;
    const ctop = control.top - origin.top;
    const cbottom = control.bottom - origin.top;
    const xmin = box.left - origin.left;
    const xmax = box.right - origin.left;
    const ymin = box.top - origin.top;
    const ymax = box.bottom - origin.top;
    const controlWithin = ctop - ymin >= 0 && ymax - cbottom >= 0;
    const possibleDirections = {
        left: controlWithin && cleft - padding - tooltip.width >= xmin,
        right: controlWithin && cright + padding + tooltip.width <= xmax,
        up: ctop - padding - tooltip.height >= ymin,
        down: cbottom + padding + tooltip.height <= ymax,
    };
    const realDirection = [
        ...directions.slice(directions.indexOf(directionEl)),
        ...directions.slice(0, directions.indexOf(directionEl)),
    ].find(dir => possibleDirections[dir]) || directionEl;
    return directionAlias[realDirection];
}
//# sourceMappingURL=utils.js.map